import { JwtPayload } from "@infrastructure/jwt/types/jwtPayload";  

export interface AuthUser {
    id: number;
    trn: string;
    firstName: string;
    lastName: string;
    email: string;
    status: number;
    getFullName: () => string;
    getEmail: () => string;
    getTrn: () => string;
    getStatus: () => number;
}

export const createAuthUser = (payload: JwtPayload): AuthUser => {
    return {
        id: payload.sub ? parseInt(payload.sub) : 0,
        trn: payload.trn ? payload.trn : '',
        firstName: payload.firstName ? payload.firstName : '',
        lastName: payload.lastName ? payload.lastName : '',
        email: payload.email ? payload.email : '',
        status: payload.status ? payload.status : 0,
        getFullName: () => `${payload.firstName} ${payload.lastName}`,
        getEmail: () => payload.email ? payload.email : '',
        getTrn: () => payload.trn ? payload.trn : '',
        getStatus: () => payload.status ? payload.status : 0,
    };
};